import { Box } from '@mui/material';

import Typography from '@/components/Typography';

interface DataHubHeaderProps {
  title: string;
  subtitle: string;
}

export const DataHubHeader = ({ title, subtitle }: DataHubHeaderProps) => {
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        gap: '8px'
      }}
    >
      <Typography
        sx={{
          fontSize: '20px',
          fontWeight: 700
        }}
      >
        {title}
      </Typography>
      <Typography
        color='textSecondary'
        sx={{
          fontSize: '14px'
        }}
      >
        {subtitle}
      </Typography>
    </Box>
  );
};
